import { createSlice } from "@reduxjs/toolkit";
import { loginAPI } from "../../../api/publicApi";
import { showErrorToast, showSuccessToast } from "../../../utils/toast";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const loginSlice = createSlice({
  name: "login",
  initialState: data,
  reducers: {
    loginSlice(state) {
      state.isLoading = true;
    },
    loginSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = null;
    },
    loginSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = action.payload;
    },
    loginSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const loginUserHandler = (data: any) => async (dispatch: any) => {
  try {
    await dispatch(loginUserAction.loginSlice());
    const response: any = await loginAPI(data);
    
    typeof localStorage !=="undefined"&&localStorage.setItem('token', response?.results?.token);
    typeof localStorage !== "undefined" && localStorage.setItem('username', response?.results?.username);
    typeof localStorage !=="undefined"&&localStorage.setItem('user_type', response?.results?.type);
    typeof localStorage !=="undefined"&&localStorage.setItem('profile_picture', response?.results?.profile_picture);
    typeof localStorage !=="undefined"&&localStorage.setItem('userId', response?.results?.user_id);
    typeof localStorage !=="undefined"&&localStorage.setItem('role', response?.results?.type);

    showSuccessToast(response?.message)
    await dispatch(loginUserAction.loginSliceSuccess(response));
  } catch (e: any) {
    showErrorToast(e?.response?.data?.error_message)
    await dispatch(loginUserAction.loginSliceFailure(e?.response?.data));
  }
};
export default loginSlice.reducer;
export const loginUserAction = loginSlice.actions;
